import "./App.css";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";

// Pages
import Home from "./pages/Home";
import Project from "./pages/Project";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import About from "./pages/About";



function App() {
  return (
    <Router>
      <Navbar />

      <Switch>
        <Route exact path="/"><Home /></Route>
        <Route exact path="/projects"><Project /></Route>
        <Route exact path="/experience"><Experience /></Route>
        <Route exact path="/education"><Education /></Route>
        <Route exact path="/about"><About /></Route>
        

        {/* 404 Page */}
        <Route path="*">
          <h2 className="text-center mt-5">404 | Page Not Found</h2>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
